// import external dependencies
import 'jquery';

// Import everything from autoload




// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import about from './routes/about';
import taxCategories from './routes/taxCategories';
import singleServices from './routes/singleServices';
import singleProjects from './routes/singleProjects';
import blog from './routes/blog';
import single from './routes/single';
import careers from './routes/careers';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About / Studio page
  about,
  // playground
  // playground,
  // Service Categories / Taxonomies
  taxCategories,
  // Services
  singleServices,
  singleProjects,
  blog,
  single,
  //careers
  careers,
});

// Load Events
jQuery(document).ready(() => {
  routes.loadEvents();
});

